import config from "../../config";
import getMinMax from "./getMinMax";

const medianOfArray = (arr) => {
    const middle = (arr.length + 1) / 2;

    // Avoid mutating when sorting
    const sorted = [...arr].sort((a, b) => a - b);
    const isEven = sorted.length % 2 === 0;

    return isEven ? (sorted[middle - 1.5]
        + sorted[middle - 0.5]) / 2 :
        sorted[middle - 1];
};

const calculateBrightnessScore = async(R, G, B, currentBrightness, currentLuminosity, lightingScore, previousLightingScore) => {
    let maxBrightness = 0.16525537699399262 * R + 0.6652148317029511 * G + -0.001003651146111617 * B + 69.29709070541365;
    let predMedianLuminance = 0.3768292657101258 * R + 0.658925987689596 * G + 0.013960139655651516 * B - 3.298445788432378;

    let relativeBrightness;

    maxBrightness = (maxBrightness <= (config.test.brightness_threshold + 66.5374)) ? maxBrightness : (config.test.brightness_threshold + 66.5374);

    if (currentBrightness <= config.test.brightness_threshold || currentBrightness > maxBrightness) {
        relativeBrightness = 0;
    }
    else if (currentBrightness > config.test.brightness_threshold && currentBrightness <= maxBrightness) {
        relativeBrightness = (currentBrightness - config.test.brightness_threshold) / (maxBrightness - config.test.brightness_threshold);
        relativeBrightness = (Math.sin(relativeBrightness*0.905+1.065)-Math.sin(1))/0.159;
    }
    else{
        relativeBrightness = 0;
    }

    // Luminance relative error coefficient calcualtion
    let luminanceResid = currentLuminosity - predMedianLuminance;

    if (Math.abs(luminanceResid) > config.test.lum_error_threshold) {
        luminanceResid = config.test.lum_error_threshold;
    }

    luminanceResid = luminanceResid / config.test.lum_error_threshold;

    let luminanceScore = 1 - (luminanceResid * luminanceResid);
    // let lightingScorePercentage = relativeBrightness * 0 + luminanceScore * 1;
    let lightingScorePercentage = (currentLuminosity / 255) * 0.5 + (currentBrightness / 255) * 0.5;
    lightingScorePercentage = lightingScorePercentage * 100;
    let newPreviousLightingScore = 0;

    if (Math.abs(previousLightingScore - lightingScorePercentage) > config.test.lighting_adjustment_threshold){
        newPreviousLightingScore = lightingScore;
    }
    else{
        newPreviousLightingScore = previousLightingScore;
    }

    return {
        lightingScore: lightingScorePercentage,
        previousLightingScore: newPreviousLightingScore
    }
};

const calculateLuminosity = async (ctx, shape, lightingScore, previousLightingScore) => {
    let count = 0, lum = 0, bri=0, totalR=0, totalG=0, totalB=0,
        luminosity, briMedian, averageR, averageB, averageG;

    let lumList = [];
    let briList = [];

    let minmax = getMinMax(shape);
    let imageData = ctx.getImageData(minmax[0], minmax[1], Math.abs(minmax[2] - minmax[0]),
        Math.abs(minmax[3] - minmax[1])).data;

    for(let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        totalR += r;
        totalG += g;
        totalB += b;

        lum = Math.sqrt((0.299 * Math.pow(r, 2)) + (0.587 * Math.pow(g, 2)) + (0.114 * Math.pow(b, 2)));
        bri = (r+g+b)/3;
        lumList.push(lum);
        briList.push(bri);
        count++;
    }

    if (count !== 0) {
        luminosity = medianOfArray(lumList);
        briMedian = medianOfArray(briList);
        averageR = totalR/count;
        averageB = totalB/count;
        averageG = totalG/count;

        return await calculateBrightnessScore(averageR, averageG, averageB, briMedian, luminosity, lightingScore, previousLightingScore);
    }
};

const calculateFPBri = (img, leftShape, rightShape) => {
    let ctx = img.getContext('2d');
    let count = 0, totalR=0, totalB=0, LeftAverageR=0, LeftAverageB=0, RightAverageR=0, RightAverageB=0;
    let minmax = getMinMax(leftShape);
    let imageData = ctx.getImageData(minmax[0], minmax[1], Math.abs(minmax[2] - minmax[0]),
        Math.abs(minmax[3] - minmax[1])).data;

    for(let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const b = imageData[i + 2];
        totalR += r;
        totalB += b;
        count++;
    }

    if (count !== 0) {
        LeftAverageR = totalR/count;
        LeftAverageB = totalB/count;
    }

    count=0;
    totalR=0;
    totalB=0;
    minmax = getMinMax(rightShape);
    imageData = ctx.getImageData(minmax[0], minmax[1], Math.abs(minmax[2] - minmax[0]),
        Math.abs(minmax[3] - minmax[1])).data;

    for(let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const b = imageData[i + 2];
        totalR += r;
        totalB += b;
        count++;
    }

    if (count !== 0) {
        RightAverageR = totalR/count;
        RightAverageB = totalB/count;

    }

    return RightAverageR > 190 || RightAverageB <= 74 || LeftAverageR > 190 || LeftAverageB <= 74;
};

export {
    calculateLuminosity,
    calculateFPBri
};